import { Checkbox } from "@/ui-components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";

export function getDataTable2SelectionColumn<TData>(): ColumnDef<TData> {
  return {
    id: "select",
    enableSorting: false,
    enableHiding: false,
    header: ({ table }) => (
      <div className="flex items-center justify-center">
        <Checkbox
          checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(Boolean(value))}
          aria-label="Alle Zeilen auswählen"
        />
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex items-center justify-center">
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(Boolean(value))}
          aria-label="Zeile auswählen"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    ),
    size: 44,
    minSize: 44,
    maxSize: 44,
  };
}

